const startDate = new Date("2020-02-27T00:00:00.000");

export default startDate;
